module.exports = __webpack_public_path__ + "static/10-04fe5295bf30cdc267618d76fe563362.jpg";